import type { SVGProps } from "react";
export interface CodeQrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CodeQrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CodeQrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M6.875 16a1.125 1.125 0 0 1 2.25 0v5c0 .621-.504 1.125-1.125 1.125H6A4.125 4.125 0 0 1 1.875 18v-2a1.125 1.125 0 0 1 2.25 0v2c0 1.035.84 1.875 1.875 1.875h.875zm4.01 5v-5a1.125 1.125 0 1 1 2.25 0v5a1.125 1.125 0 0 1-2.25 0m6.624-10.125a1.125 1.125 0 0 1 0 2.25h-2a1.125 1.125 0 0 1 0-2.25zm3.501 0a1.125 1.125 0 0 1 0 2.25H21a1.125 1.125 0 0 1 0-2.25zM14.875 8v-.834a1.126 1.126 0 0 1 2.25 0V8a1.125 1.125 0 0 1-2.25 0m5 0V6c0-1.036-.84-1.875-1.875-1.875h-2a1.125 1.125 0 0 1 0-2.25h2A4.125 4.125 0 0 1 22.125 6v2a1.125 1.125 0 0 1-2.25 0m0 9.125h-2.75v2.75H18c1.035 0 1.875-.84 1.875-1.875zM3.01 10.875l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H3a1.125 1.125 0 0 1 0-2.25zM10.885 7a1.125 1.125 0 1 1 2.25 0v5c0 .621-.503 1.125-1.125 1.125H6.5a1.125 1.125 0 0 1 0-2.25h4.385zM8 1.875c.62 0 1.125.504 1.125 1.125v5c0 .62-.504 1.125-1.125 1.125H3A1.125 1.125 0 0 1 1.875 8V6A4.125 4.125 0 0 1 6 1.875zm4.01 0 .114.006a1.125 1.125 0 0 1 0 2.238l-.114.006H12a1.125 1.125 0 0 1 0-2.25zM22.125 18A4.125 4.125 0 0 1 18 22.125h-2A1.125 1.125 0 0 1 14.876 21v-5c0-.62.503-1.124 1.124-1.124h5c.621 0 1.125.503 1.125 1.124zm-18-11.125h2.75v-2.75H6c-1.036 0-1.875.84-1.875 1.875z"
      />
    </svg>
  );
}
